import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export const approvalQuestionFormSchema = z.object({
  comment: z.string().nonempty('Comment is required'),
  files: z.array(z.any())
});

export type ApprovalQuestionFormValues = z.infer<
  typeof approvalQuestionFormSchema
>;

export const useApprovalQuestionForm = (
  defaultValues?: Partial<ApprovalQuestionFormValues>
) => {
  return useForm<ApprovalQuestionFormValues>({
    resolver: zodResolver(approvalQuestionFormSchema),
    defaultValues: {
      ...defaultValues
    }
  });
};
